import { Text } from '@portals/ui-kit';
import classnames from 'classnames/bind';
import { useTranslations } from 'next-intl';
import { FOOTER_BUTTONS } from '@/_pages/categories/_components/footer/_constants';
import FooterLink from './_components/footer-all-social-button';
import styles from './index.module.scss';
import { EAnalyticsEvents } from '@/_analytic/_types';
import { getAnalyticsClickAttr } from '@/_analytic/_utils/get-analytics-click-attr/get-analytics-click-attr';
import { FooterButton } from './_components/footer-button';

const BLOCK_NAME = 'FooterControls';
const cn = classnames.bind(styles);

export const FooterControls = () => {
  const translations = useTranslations('categories.footer');
  const subscribeToChannelsText = translations('title');

  return (
    <div className={cn(BLOCK_NAME)}>
      <Text color="normalGrey" size="body-s" text={subscribeToChannelsText} />
      <div className={cn(`${BLOCK_NAME}__buttons`)}>
        {FOOTER_BUTTONS.map(({ icon, id, link, text }) => {
          return (
            <div
              key={id}
              data-button-text={text}
              {...getAnalyticsClickAttr({
                name: EAnalyticsEvents.CATEGORIES_FOOTER_CLICK,
                params: { buttonName: text },
              })}
            >
              <FooterButton label={text} leadingSlot={icon} href={link} />
            </div>
          );
        })}
        <FooterLink />
      </div>
    </div>
  );
};
